import { Alert, Input } from "antd";
import { ChangeEventHandler } from "react";
import { UserFormInterface } from "../definitions";

interface objectInterface {
  [key: string]: string;
}

interface InputInterface {
  errors: objectInterface;
  fillableForm: ChangeEventHandler<HTMLInputElement>;
  name: string;
  placeholder: string;
  prefix?: string;
  userForm: UserFormInterface;
  displayName?: string;
  autoComplete?: string;
  type?: string;
  min?: number;
  max?: number;
}

function InputHolder({
  errors,
  fillableForm,
  name,
  placeholder,
  prefix,
  userForm,
  displayName,
  autoComplete,
  type,
  min,
  max,
}: InputInterface) {
  if (displayName === undefined || displayName === "") {
    displayName = placeholder;
  }

  const inputStyle: Object = {
    width: "100%",
  };

  let str = name as keyof typeof userForm;

  // Custom handler for phone input to prevent +370 duplication and handle autofill formats
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (name === "customer_phone_no" && prefix === "+370") {
      let value = e.target.value;
      // Remove any +370 or 370 prefix (international format from autofill)
      value = value.replace(/^\+?370/, "");
      // Only allow digits
      value = value.replace(/\D/g, "");
      // Strip leading 8 or 0 (Lithuanian local format: 860950990 or 060950990)
      if (value.length > 8 && (value.startsWith("8") || value.startsWith("0"))) {
        value = value.substring(1);
      }
      // Limit to 8 digits
      value = value.substring(0, 8);
      e.target.value = value;
    }
    fillableForm(e);
  };

  // Custom handler for number inputs to ensure only numbers
  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "number") {
      let value = e.target.value;
      // Only allow digits
      value = value.replace(/\D/g, "");
      // Apply min/max constraints if provided
      if (value !== "") {
        const numValue = parseInt(value, 10);
        if (min !== undefined && numValue < min) {
          value = min.toString();
        }
        if (max !== undefined && numValue > max) {
          value = max.toString();
        }
      }
      e.target.value = value;
    }
    fillableForm(e);
  };

  const isEmailField = name === "customer_email";
  const inputType = type || (isEmailField ? "email" : "text");

  return (
    <>
      {errors[name] !== undefined ? (
        <Alert banner showIcon message={errors[name]} type="error" />
      ) : null}
      <label>{displayName}</label>
      <Input
        type={inputType}
        prefix={prefix}
        onChange={
          name === "customer_phone_no" && prefix === "+370"
            ? handlePhoneChange
            : type === "number"
            ? handleNumberChange
            : fillableForm
        }
        value={
          userForm[str] !== "" && userForm[str] !== 0 ? String(userForm[str] ?? "") : ""
        }
        name={name}
        style={inputStyle}
        autoComplete={autoComplete}
        placeholder={placeholder}
        min={min}
        max={max}
      />
    </>
  );
}

export default InputHolder;
